interface VideoEmbedProps {
  youtubeId?: string;
  videoSrc?: string;
  title: string;
}

const VideoEmbed = ({ youtubeId, videoSrc, title }: VideoEmbedProps) => {
  // If a local video source is provided, use video element
  if (videoSrc) {
    return (
      <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-lg">
        <video
          src={videoSrc}
          title={title}
          controls
          className="absolute top-0 left-0 w-full h-full object-cover"
          preload="metadata"
        />
      </div>
    );
  }

  // Default to YouTube embed
  return (
    <div className="relative w-full aspect-video rounded-xl overflow-hidden shadow-lg">
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${youtubeId}?modestbranding=1&rel=0`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="absolute top-0 left-0 w-full h-full"
        loading="lazy"
      />
    </div>
  );
};

export default VideoEmbed;
